import { SpacingProps, spacingStyles } from 'component-library/styles/spacing';
import styled from 'styled-components';

export interface FlexProps extends SpacingProps {
  column?: boolean;
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'end';
  gap?: number;
  justifyContent?:
    | 'space-between'
    | 'center'
    | 'flex-end'
    | 'space-around'
    | 'flex-start';
}

export const Flex = styled.div<FlexProps>`
  display: flex;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  align-items: ${({ alignItems }) => alignItems || 'unset'};
  justify-content: ${({ justifyContent }) => justifyContent || 'unset'};
  gap: ${({ gap }) => gap || 0}px;

  ${spacingStyles}
`;
